
(function () {
  "use strict";

  const QUESTIONS = [
    {
      question: "What are the basic price components of a candlestick?",
      choices: [
        "Closing price, High price, Opening price, Low price",
        "Opening price, Closing price, High price, Volume",
        "Opening price, Closing price, and Midpoint of the day",
        "High Price and Low Price"
      ],
      answer: "A"
    },
    {
      question: "What makes up a candlestick's real body?",
      choices: [
        "The open and low prices",
        "The open and closing prices",
        "The high and low prices",
        "None of the above"
      ],
      answer: "B"
    },
    {
      question: "What statement is true about Doji candlesticks?",
      choices: [
        "It shows indecision in the market",
        "The bottom wick must be longer than the top wick",
        "It has the same Open and Closing price",
        "A and C"
      ],
      answer: "D"
    },
    {
      question: "Which statement is false about candlestick wicks/shadows?",
      choices: [
        "Wicks are the high and low price of the candle period",
        "The upper wick of a Red candle is the lowest price",
        "Longer wicks show indecision",
        "None of the above"
      ],
      answer: "B"
    },
    {
      question: "Which of the following is not a real Doji candle category?",
      choices: [
        "Dragonfly",
        "Deliberating",
        "Gravestone",
        "4 Price"
      ],
      answer: "B"
    },
    {
      question: "What type of candlestick pattern is highlighted on the chart?",
      choices: [
        "Bullish Breakaway",
        "Bearish Tri-Star",
        "Bearish Harami",
        "Bearish Kicking"
      ],
      answer: "A",
      image: true
    },
    {
      question: "When are reversal patterns the most reliable?",
      choices: [
        "In a trend",
        "In a sideways, range trading market",
        "When they occur over a longer period of time",
        "All of the above"
      ],
      answer: "C"
    },
    {
      question: "Which of the following is true about the inverted Hammer candle?",
      choices: [
        "Inverted hammers always have long bodies",
        "An inverted hammer has equally long upper and lower wicks",
        "An inverted hammer candle indicates a potential trend reversal",
        "A Hammer is a warning sign to Bullish buyers"
      ],
      answer: "C"
    },
    {
      question: "Which of the following is a one-day reversal pattern?",
      choices: [
        "Spinning Top",
        "Hammer",
        "Marubozu",
        "Bearish Engulfing"
      ],
      answer: "B"
    },
    {
      question: "Which of the following is a reversal candlestick pattern?",
      choices: [
        "Three Black Crows",
        "Advanced Block",
        "Tweezer Top",
        "Morning Star"
      ],
      answer: "D"
    },
    {
      question: "Which of the following is a Bullish Engulfing Pattern?",
      choices: [
        "Figure 1",
        "Figure 2",
        "Figure 3",
        "Figure 4"
      ],
      answer: "C",
      hint: "This pattern shows sellers in control at first, but buyers overpower them, signaling a potential reversal upward."
    },
    {
      question: "Which of the following is true about the Rising Three Pattern?",
      choices: [
        "It is a bullish reversal pattern",
        "It occurs in a downtrend",
        "The inside bars are Bullish",
        "Buyers are in control"
      ],
      answer: "D"
    },
    {
      question: "Which of the following is not true about trading channels?",
      choices: [
        "They can be bullish or bearish",
        "Channels are reversal signals",
        "They are made of support and resistance levels",
        "None of the above"
      ],
      answer: "B"
    },
    {
      question: "Which of the following is not true about the Cup and Handle pattern?",
      choices: [
        "It is a bearish continuation pattern",
        "It is usually seen in uptrending patterns",
        "It is made of support and resistance",
        "They utilize the breakout strategy"
      ],
      answer: "A"
    },
    {
      question: "Which of the following is a bearish continuation pattern that consists of a long bearish candle in a downtrend, followed by weak bullish candles that push prices higher?",
      choices: [
        "Bullish Engulfing",
        "Tweezer Top",
        "Falling Three",
        "Bearish Harami"
      ],
      answer: "C"
    },
    {
      question: "Which of the following is a Bullish Abandoned Baby Pattern?",
      choices: [
        "Figure 1",
        "Figure 2",
        "Figure 3",
        "Figure 4"
      ],
      answer: "B"
    },
    {
      question: "Which of the following are characteristic of a Double Top pattern?",
      choices: [
        "Strongest when seen at the top of an uptrend",
        "It is a bullish signal",
        "Consists of two strong resistance points",
        "Both A and C"
      ],
      answer: "D"
    },
    {
      question: "What is the name of this reversal pattern?",
      choices: [
        "Dark Cloud Cover",
        "Evening Star",
        "Bearish Engulfing",
        "Descending Block",
        "Other"
      ],
      answer: "A",
      image: true
    },
    {
      question: "What is a characteristic of the Bullish Tri-star pattern?",
      choices: [
        "It is a Bearish Reversal pattern",
        "It appears in an uptrend",
        "The inside and outside doji bars show certainty",
        "Buyers are in control"
      ],
      answer: "D"
    },
    {
      question: "What type of pattern is an Upside Gap?",
      choices: [
        "Bearish Reversal Pattern",
        "Bullish Reversal Pattern",
        "Bullish Continuation Pattern",
        "Bearish Continuation Pattern"
      ],
      answer: "C"
    },
    {
      question: "What is the name of this Bearish continuation pattern?",
      choices: [
        "Bearish Inside Bar",
        "Ascending Triangle",
        "Bearish Kicker",
        "Downside Gap"
      ],
      answer: "A",
      image: true
    },
    {
      question: "How can moving averages be used to identify a trend?",
      choices: [
        "Moving Average volume on the daily chart",
        "By the location of the price above or below the moving averages",
        "By the slope or direction of the moving averages (up or down)",
        "All of the above",
        "B & C"
      ],
      answer: "E"
    },
    {
      question: "Which of these are neutral two-candle patterns that represent continuations in the current trend?",
      choices: [
        "Gravestone Doji",
        "Bullish/Bearish Harami Lines",
        "Ascending Triangles",
        "Separating Lines",
        "B & D"
      ],
      answer: "D"
    },
    {
      question: "Candlestick patterns analysis is the most legitimate when...",
      choices: [
        "The volume is high.",
        "Hot news comes out about a company.",
        "It's done during after hours.",
        "Compared with other indicators.",
        "A & D"
      ],
      answer: "A"
    },
    {
      question: "Which of the following is often used as strong confirmation for a reversal pattern?",
      choices: [
        "A Marubozu candlestick",
        "A Cup & Handle chart pattern",
        "A Support or Resistance break",
        "Higher trading volume"
      ],
      answer: "C"
    },
    {
      question: "Which of the following is true about candle gaps?",
      choices: [
        "Price gaps usually occur during pre-market and after hours.",
        "Gaps indicate low volume.",
        "Gap fills are strong bullish signals.",
        "Gap fills are reversal patterns."
      ],
      answer: "A"
    },
    {
      question: "Which of the following is true about the Descending Triangle pattern?",
      choices: [
        "It is a bearish continuation pattern",
        "It's made of lower highs and steady lows",
        "Traders tend to place entry positions at the support breakout",
        "All of the above"
      ],
      answer: "D"
    },
    {
      question: "Which of these candlesticks is not a simple (two-day) pattern?",
      choices: [
        "Dark Cloud Cover",
        "Double Bottom",
        "Piercing Line",
        "Engulfing"
      ],
      answer: "B"
    },
    {
      question: "What is the name of this reversal pattern?",
      choices: [
        "Inverse Head & Shoulders",
        "Bearish Deliberating",
        "Descending Block",
        "Head & Shoulders"
      ],
      answer: "D",
      image: true
    },
    {
      question: "What is the name of the reversal pattern below?",
      choices: [
        "Bullish Tri-Star",
        "Bearish Deliberating",
        "Bearish Breakaway",
        "Three Green Soldiers"
      ],
      answer: "D",
      image: true
    }
  ];

  // Explanations adapted from the Answer Key and Comments
  // section of the supplied BGS review-card quiz PDF.
  const EXPLANATIONS = [
    "A candlestick records four basic prices: open, high, low, and close. The real body spans the opening and closing prices, while the wicks show the highest and lowest prices traded during the period.",
    "The real body is the wide area between the open and close. Green usually indicates a close above the open, while red usually indicates a close below the open.",
    "A Doji has nearly equal opening and closing prices and can reflect uncertainty between buyers and sellers. It can appear near a reversal, but a Doji by itself is not confirmation of a trend change.",
    "The upper wick represents the highest traded price during the candle period, regardless of whether the candle is red or green. The lower wick represents the lowest traded price.",
    "Deliberating is not a Doji category. The PDF describes it as a three-line bearish reversal formation. Recognized Doji varieties include the Common, Gravestone, Dragonfly, and Long-Legged Doji.",
    "The Bullish Breakaway is a multi-candle reversal formation that may appear after an extended decline. A series of weakening bearish candles is followed by stronger buying pressure as the final candle advances.",
    "Reversal patterns should be considered in the context of the preceding trend and supporting price action. Longer-form developments can offer additional evidence, but a reversal signal still needs confirmation.",
    "An Inverted Hammer typically has a small real body and a much longer upper wick. When it appears after a downtrend, it may warn that buying pressure is starting to emerge.",
    "A Hammer is a single-candlestick reversal signal that can suggest the possibility of an upward price move, especially after a downtrend. A Spinning Top more generally shows indecision.",
    "The Morning Star is a bullish reversal pattern that typically forms after a downtrend. Its candles suggest that selling momentum is weakening and buyers are gaining strength.",
    "Bullish Engulfing consists of a smaller bearish candle followed by a larger bullish candle whose real body engulfs the earlier real body. In the original PDF's four figures, the Bullish Engulfing example was Figure 3.",
    "Rising Three is a bullish continuation formation. A strong bullish candle is followed by several smaller bearish candles contained within its range, and then another bullish candle resumes the upward move.",
    "A trading channel is formed by support and resistance boundaries. Channels may slope upward or downward, but the channel itself does not automatically mean the trend will reverse.",
    "A Cup and Handle is generally considered a bullish continuation pattern. The cup represents consolidation and the handle precedes a potential breakout from resistance.",
    "The described bearish continuation formation is Falling Three. A large bearish candle is followed by relatively small upward or sideways corrective candles before selling pressure resumes. The printed PDF's answer B conflicts with the wording of this question.",
    "The Bullish Abandoned Baby is a three-candle reversal formation in a downtrend: a bearish candle, a downward-gapped Doji, and then a bullish candle that gaps upward. In the original PDF's figures, the example was Figure 2.",
    "A Double Top is a bearish reversal chart pattern with two peaks around the same resistance zone. The pattern is generally confirmed by a break below the support level between those peaks.",
    "The figure shows a Dark Cloud Cover setup. It involves a bearish candle opening above the previous bullish candle's close and then closing below the bullish candle's midpoint. The PDF's explanation names Dark Cloud Cover although its printed answer letter says E.",
    "A Bullish Tri-Star is a bullish reversal pattern built around three Doji candles after a decline. The transition can reflect weakening selling pressure and the possibility of buyers gaining control.",
    "An Upside Gap during an uptrend can signal bullish continuation. The gap reflects buying momentum and may support the idea that the existing advance can continue.",
    "A Bearish Inside Bar develops when a smaller candle forms inside the range of the preceding candle. In a bearish trend, this consolidation may precede renewed downside movement.",
    "Price relative to a moving average and the moving average's slope can both help identify the trend. Price holding above a rising average often supports an uptrend; price below a falling average often supports a downtrend.",
    "Separating Lines are a two-candle continuation formation. The pattern suggests that the existing bullish or bearish trend is likely to continue rather than reverse.",
    "The PDF emphasizes higher trading volume as confirmation of candlestick patterns because it reflects stronger market participation. Price action and other indicators can provide additional context.",
    "A break of important support or resistance can strengthen a reversal signal by showing a change in market participation. A former support level may become resistance, and former resistance may become support.",
    "A price gap appears when the market opens materially above or below a previous trading level, leaving an untraded area on the chart. New information during premarket or after-hours periods can contribute to such gaps.",
    "A Descending Triangle has declining highs pressing toward a relatively flat support area. A break below support can signal continuation of bearish pressure, though breakouts can fail.",
    "A Double Bottom is a chart formation with two comparable lows separated by a rebound. Unlike the two-candlestick examples listed, it normally develops over a longer price sequence.",
    "Head & Shoulders is a bearish reversal chart pattern with a left shoulder, a higher head, and a right shoulder. A break beneath its neckline can confirm a potential change from an uptrend toward a downtrend. The PDF's final two explanations appear reversed.",
    "Three Green Soldiers consists of three successive strong bullish candles advancing higher. It can point to growing buying pressure and a potential bullish reversal after a decline. The PDF's final two explanations appear reversed."
  ];

  const LETTERS = ["A", "B", "C", "D", "E"];
  const PER_PAGE = 3;
  const FIGURE_QUESTIONS = [11, 16];
  const ORIGINAL_CORRECT = { 11: 3, 16: 2 };
  const TOTAL_PAGES = Math.ceil(QUESTIONS.length / PER_PAGE);

  function initQuiz(root) {
    if (root.dataset.ready === "yes") return;
    root.dataset.ready = "yes";

    const answers = new Array(QUESTIONS.length).fill(null);
    let page = 0;
    let currentScreen = "welcome";
    let reportDate = null;

    const figureOrders = {
      11: [1, 2, 3, 4],
      16: [1, 2, 3, 4]
    };

    const STORAGE_KEY =
      "bgs-candlestick-quiz-progress-v3:" +
      window.location.pathname;

    const $ = (selector) => root.querySelector(selector);

    const screens = {
      welcome: $('[data-view="welcome"]'),
      quiz: $('[data-view="quiz"]'),
      results: $('[data-view="results"]')
    };

    function isValidFigureOrder(order) {
      return Array.isArray(order) &&
        order.length === 4 &&
        order.every((n) => Number.isInteger(n) && n >= 1 && n <= 4) &&
        new Set(order).size === 4;
    }

    function saveProgress() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          version: 3,
          answers: answers.slice(),
          page,
          screen: currentScreen,
          reportDate,
          figureOrders: {
            11: figureOrders[11].slice(),
            16: figureOrders[16].slice()
          }
        }));
      } catch (error) {
        // Browser storage may not be available.
      }
    }

    function restoreProgress() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;

        const saved = JSON.parse(raw);

        if (
          saved.version !== 3 ||
          !Array.isArray(saved.answers) ||
          saved.answers.length !== QUESTIONS.length ||
          !saved.figureOrders ||
          !isValidFigureOrder(saved.figureOrders[11]) ||
          !isValidFigureOrder(saved.figureOrders[16])
        ) {
          return false;
        }

        saved.answers.forEach((value, index) => {
          const choices = LETTERS.slice(0, QUESTIONS[index].choices.length);
          answers[index] = choices.includes(value) ? value : null;
        });

        page = Number.isInteger(saved.page)
          ? Math.max(0, Math.min(TOTAL_PAGES - 1, saved.page))
          : 0;

        figureOrders[11] = saved.figureOrders[11].slice();
        figureOrders[16] = saved.figureOrders[16].slice();

        reportDate = typeof saved.reportDate === "string"
          ? saved.reportDate
          : null;

        currentScreen =
          saved.screen === "results" && answers.every(Boolean)
            ? "results"
            : saved.screen === "quiz" || answers.some(Boolean)
            ? "quiz"
            : "welcome";

        return true;
      } catch (error) {
        return false;
      }
    }

    function show(screen, shouldSave = true, shouldScroll = true) {
      currentScreen = screen;

      Object.keys(screens).forEach((key) => {
        screens[key].hidden = key !== screen;
      });

      if (shouldSave) saveProgress();

      if (shouldScroll) {
        root.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }

    function shuffleFigureOrder(questionNumber) {
      const previous = figureOrders[questionNumber].join(",");
      const next = [1, 2, 3, 4];

      for (let i = next.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [next[i], next[j]] = [next[j], next[i]];
      }

      if (next.join(",") === previous) {
        next.push(next.shift());
      }

      figureOrders[questionNumber] = next;
    }

    function correctAnswerFor(index) {
      const questionNumber = index + 1;

      if (FIGURE_QUESTIONS.includes(questionNumber)) {
        const correctOriginal = ORIGINAL_CORRECT[questionNumber];
        const displayedIndex =
          figureOrders[questionNumber].indexOf(correctOriginal);

        return LETTERS[displayedIndex];
      }

      return QUESTIONS[index].answer;
    }

    function correctAnswerText(index) {
      const number = index + 1;

      if (number === 11) return "Bullish Engulfing";
      if (number === 16) return "Bullish Abandoned Baby";

      const letter = correctAnswerFor(index);
      return QUESTIONS[index].choices[LETTERS.indexOf(letter)];
    }

    function updateProgress() {
      const answered = answers.filter(Boolean).length;
      const percent = (answered / QUESTIONS.length) * 100;
      const fill = $('[data-progress-fill]');

      if (fill) {
        fill.style.setProperty("width", percent + "%", "important");
        fill.style.setProperty("height", "100%", "important");
        fill.style.setProperty("background", "#2bad5e", "important");
        fill.style.setProperty("opacity", "1", "important");
        fill.style.setProperty("visibility", "visible", "important");
        fill.style.setProperty("display", "block", "important");
        fill.style.setProperty("transform", "none", "important");
      }

      const track = root.querySelector(
        '.bgs-cq__progress[role="progressbar"]'
      );

      if (track) {
        track.setAttribute("aria-valuenow", String(answered));
      }

      $('[data-progress-count]').textContent =
        `${answered} OF ${QUESTIONS.length} ANSWERED`;
    }

    function appendSingleImage(index, block) {
      const source = root.querySelector(
        `[data-question-image-number="${index + 1}"]`
      );

      if (!source || !source.dataset.url) {
        const notice = document.createElement("p");
        notice.className = "bgs-cq__image-notice";
        notice.textContent =
          `Question ${index + 1} image not selected yet.`;
        block.append(notice);
        return;
      }

      const wrap = document.createElement("div");
      wrap.className = "bgs-cq__question-image-wrap";

      const image = document.createElement("img");
      image.src = source.dataset.url;
      image.loading = "lazy";
      image.alt =
        `Candlestick pattern illustration for question ${index + 1}`;

      wrap.append(image);
      block.append(wrap);
    }

    function appendFigureGrid(index, block) {
      const number = index + 1;
      const grid = document.createElement("div");
      grid.className = "bgs-cq__figure-grid";

      figureOrders[number].forEach((original, displayedIndex) => {
        const source = root.querySelector(
          `[data-figure-question="${number}"]` +
          `[data-figure-slot="${original}"]`
        );

        const figure = document.createElement("figure");
        figure.className = "bgs-cq__figure-card";

        if (source && source.dataset.url) {
          const image = document.createElement("img");
          image.src = source.dataset.url;
          image.loading = "lazy";
          image.alt = `Figure ${displayedIndex + 1}`;
          figure.append(image);
        } else {
          const notice = document.createElement("p");
          notice.className = "bgs-cq__image-notice";
          notice.textContent = "Image not selected";
          figure.append(notice);
        }

        const caption = document.createElement("figcaption");
        caption.textContent = `Figure ${displayedIndex + 1}`;

        figure.append(caption);
        grid.append(figure);
      });

      block.append(grid);
    }

    function renderPage() {
      const start = page * PER_PAGE;
      const end = Math.min(start + PER_PAGE, QUESTIONS.length);

      $('[data-progress-label]').textContent =
        `QUESTIONS ${String(start + 1).padStart(2, "0")}` +
        `–${String(end).padStart(2, "0")} OF ${QUESTIONS.length}`;

      const list = $('[data-answers]');
      list.replaceChildren();

      for (let index = start; index < end; index++) {
        const question = QUESTIONS[index];

        const block = document.createElement("article");
        block.className = "bgs-cq__question-block";
        block.dataset.questionIndex = String(index);

        const number = document.createElement("span");
        number.className = "bgs-cq__question-number";
        number.textContent =
          `QUESTION ${String(index + 1).padStart(2, "0")}`;

        const heading = document.createElement("h2");
        heading.className = "bgs-cq__question-heading";
        heading.textContent = question.question;

        block.append(number, heading);

        if (question.hint) {
          const hint = document.createElement("p");
          hint.className = "bgs-cq__question-hint";
          hint.textContent = question.hint;
          block.append(hint);
        }

        if (FIGURE_QUESTIONS.includes(index + 1)) {
          appendFigureGrid(index, block);
        } else if (question.image) {
          appendSingleImage(index, block);
        }

        const group = document.createElement("div");
        group.className = "bgs-cq__answer-group";
        group.setAttribute("role", "radiogroup");
        group.setAttribute(
          "aria-label",
          `Answers to question ${index + 1}`
        );

        question.choices.forEach((choice, choiceIndex) => {
          const letter = LETTERS[choiceIndex];

          const label = document.createElement("label");
          label.className = "bgs-cq__answer-option";

          const radio = document.createElement("input");
          radio.type = "radio";
          radio.name = `bgs-answer-${root.id}-${index}`;
          radio.value = letter;
          radio.checked = answers[index] === letter;

          const marker = document.createElement("b");
          marker.textContent = letter;

          const text = document.createElement("span");
          text.textContent = choice;

          radio.addEventListener("change", () => {
            answers[index] = letter;
            block.classList.remove(
              "bgs-cq__question-block--missing"
            );
            $('[data-answer-error]').hidden = true;
            updateProgress();
            saveProgress();
          });

          label.append(radio, marker, text);
          group.append(label);
        });

        block.append(group);
        list.append(block);
      }

      $('[data-action="previous"]').disabled = page === 0;

      const next = $('[data-action="next"]');
      next.textContent =
        end === QUESTIONS.length
          ? "SEE MY RESULTS →"
          : "NEXT 3 QUESTIONS →";

      next.style.setProperty("color", "#ffffff", "important");
      next.style.setProperty(
        "-webkit-text-fill-color",
        "#ffffff",
        "important"
      );

      $('[data-answer-error]').hidden = true;
      updateProgress();
    }

    function getGrade(score) {
      if (score <= 9) {
        return [
          "Needs Work",
          "Your understanding of candlestick patterns is still developing. Review the fundamentals with your Candlestick Review Cards and try again."
        ];
      }

      if (score <= 19) {
        return [
          "Making Progress",
          "You've built a foundation. Review the patterns that gave you trouble and aim to improve your score."
        ];
      }

      if (score <= 25) {
        return [
          "Solid Understanding",
          "You have a strong understanding of candlestick patterns and their practical applications. Keep practicing with your review cards."
        ];
      }

      return [
        "Mastery Level",
        "Congratulations! You have an advanced grasp of candlestick patterns. Keep practicing and applying what you've learned."
      ];
    }

    function calculateScore() {
      return QUESTIONS.reduce((total, question, index) => {
        return total +
          (answers[index] === correctAnswerFor(index) ? 1 : 0);
      }, 0);
    }

    function renderPersonalReview() {
      const review = $('[data-review]');
      review.replaceChildren();

      QUESTIONS.forEach((question, index) => {
        const correctLetter = correctAnswerFor(index);
        const correct = answers[index] === correctLetter;

        const item = document.createElement("article");
        item.className = "bgs-cq__review-item";
        item.dataset.correct = String(correct);

        const header = document.createElement("div");
        header.className = "bgs-cq__review-header";

        const heading = document.createElement("h4");
        heading.textContent = `${index + 1}. ${question.question}`;

        const status = document.createElement("span");
        status.className = "bgs-cq__review-status";
        status.textContent = correct ? "CORRECT" : "REVIEW";

        header.append(heading, status);

        const selectedIndex = LETTERS.indexOf(answers[index]);
        const selected = document.createElement("p");

        selected.textContent =
          `Your answer: ${answers[index] || "Unanswered"}` +
          (selectedIndex >= 0
            ? ` — ${question.choices[selectedIndex]}`
            : "");

        const key = document.createElement("p");
        key.textContent =
          `Answer key: ${correctLetter} — ` +
          correctAnswerText(index);

        item.append(header, selected, key);
        review.append(item);
      });
    }

    function renderFullAnswerKey() {
      const container = $('[data-full-answer-key]');
      container.replaceChildren();

      QUESTIONS.forEach((question, index) => {
        const item = document.createElement("article");
        item.className = "bgs-cq__key-item";

        const heading = document.createElement("h4");
        heading.textContent = `${index + 1}. ${question.question}`;

        const answer = document.createElement("p");
        answer.className = "bgs-cq__key-correct";
        answer.textContent =
          `Answer: ${correctAnswerFor(index)} — ` +
          correctAnswerText(index);

        const explanation = document.createElement("p");
        explanation.textContent = EXPLANATIONS[index];

        item.append(heading, answer, explanation);
        container.append(item);
      });
    }

    function showResults(restoring = false) {
      const score = calculateScore();
      const percent = Math.round(score / QUESTIONS.length * 100);
      const [grade, description] = getGrade(score);

      if (!reportDate) {
        reportDate = new Date().toISOString();
      }

      $('[data-score]').textContent =
        `${score} / ${QUESTIONS.length}`;
      $('[data-score-percent]').textContent =
        `${percent}%`;
      $('[data-grade]').textContent = grade;
      $('[data-grade-description]').textContent =
        description;
      $('[data-report-correct]').textContent = String(score);
      $('[data-report-review]').textContent =
        String(QUESTIONS.length - score);

      $('[data-report-date]').textContent =
        new Intl.DateTimeFormat(undefined, {
          year: "numeric",
          month: "long",
          day: "numeric"
        }).format(new Date(reportDate));

      renderPersonalReview();
      renderFullAnswerKey();

      show("results", !restoring, !restoring);
    }

    function startFreshQuiz() {
      answers.fill(null);
      page = 0;
      reportDate = null;

      FIGURE_QUESTIONS.forEach(shuffleFigureOrder);

      const answerKey = root.querySelector(".bgs-cq__answer-key");
      if (answerKey) answerKey.open = false;

      renderPage();
      show("quiz");
    }

    function buildPdfReport() {
      if (!window.jspdf || !window.jspdf.jsPDF) {
        return false;
      }

      const score = calculateScore();
      const percent = Math.round(score / QUESTIONS.length * 100);
      const [grade, description] = getGrade(score);

      const doc = new window.jspdf.jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "letter"
      });

      const margin = 44;
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const usableWidth = pageWidth - margin * 2;
      const bottom = pageHeight - 52;
      let y = margin;

      function newPageIfNeeded(height) {
        if (y + height > bottom) {
          doc.addPage();
          y = margin;
        }
      }

      function line(text, options = {}) {
        const size = options.size || 10;
        const leading = options.leading || size * 1.5;
        const weight = options.bold ? "bold" : "normal";

        doc.setFont("helvetica", weight);
        doc.setFontSize(size);
        doc.setTextColor(
          options.muted ? 90 : 25,
          options.muted ? 100 : 30,
          options.muted ? 96 : 30
        );

        const wrapped = doc.splitTextToSize(
          String(text),
          usableWidth
        );

        newPageIfNeeded(wrapped.length * leading + 8);
        doc.text(wrapped, margin, y);
        y += wrapped.length * leading + (options.gap || 8);
      }

      function divider() {
        newPageIfNeeded(20);
        doc.setDrawColor(221, 229, 224);
        doc.line(margin, y, pageWidth - margin, y);
        y += 17;
      }

      doc.setTextColor(22, 137, 67);
      line("BLACK GIRL STOCKS / ASSESSMENT REPORT", {
        size: 10,
        bold: true,
        gap: 16
      });

      line("Candlestick Knowledge Check", {
        size: 21,
        bold: true,
        gap: 12
      });

      line(
        new Intl.DateTimeFormat(undefined, {
          month: "long",
          day: "numeric",
          year: "numeric"
        }).format(new Date(reportDate || Date.now())),
        { size: 10, muted: true }
      );

      divider();

      line(`OVERALL SCORE: ${score}/30 (${percent}%)`, {
        size: 17,
        bold: true
      });
      line(`PERFORMANCE LEVEL: ${grade}`, {
        size: 12,
        bold: true
      });
      line(description, { size: 10 });
      line(
        `Correct answers: ${score}    To review: ${30 - score}`,
        { size: 10 }
      );

      divider();
      line("PERSONAL ANSWER REVIEW", {
        size: 14,
        bold: true
      });

      QUESTIONS.forEach((question, index) => {
        const selected = answers[index];
        const letter = correctAnswerFor(index);
        const correct = selected === letter;

        const answerIndex = LETTERS.indexOf(selected);
        const chosenText = answerIndex >= 0
          ? question.choices[answerIndex]
          : "Unanswered";

        newPageIfNeeded(80);

        line(`${index + 1}. ${question.question}`, {
          size: 10,
          bold: true,
          gap: 5
        });

        line(
          `Your answer: ${selected || "-"} - ${chosenText}`,
          { size: 9, muted: true, gap: 4 }
        );

        line(
          `Correct answer: ${letter} - ${correctAnswerText(index)}`,
          { size: 9, gap: 4 }
        );

        line(correct ? "CORRECT" : "REVIEW", {
          size: 9,
          bold: true,
          gap: 10
        });
      });

      doc.addPage();
      y = margin;

      line("COMPLETE ANSWER KEY", {
        size: 17,
        bold: true
      });

      line("All 30 questions with explanations", {
        size: 10,
        muted: true,
        gap: 16
      });

      QUESTIONS.forEach((question, index) => {
        newPageIfNeeded(105);

        line(`${index + 1}. ${question.question}`, {
          size: 10,
          bold: true,
          gap: 5
        });

        line(
          `Answer: ${correctAnswerFor(index)} - ${correctAnswerText(index)}`,
          { size: 10, bold: true, gap: 6 }
        );

        line(EXPLANATIONS[index], {
          size: 9,
          leading: 14,
          gap: 17
        });
      });

      const total = doc.internal.getNumberOfPages();

      for (let p = 1; p <= total; p++) {
        doc.setPage(p);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.setTextColor(120);
        doc.text(
          `BGS Candlestick Knowledge Check  |  Page ${p} of ${total}`,
          margin,
          pageHeight - 28
        );
      }

      return doc;
    }

    function savePdf() {
      const help = $('[data-pdf-help]');
      const doc = buildPdfReport();

      if (!doc) {
        if (help) {
          help.textContent =
            "PDF generation is unavailable in this preview. Open the quiz in Safari or Chrome and try again, or use the browser's Print option.";
        }
        window.print();
        return;
      }

      const filename = "BGS-Candlestick-Knowledge-Check-Results.pdf";
      const isiPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isiPhone) {
        // On iOS, open the actual PDF so Share → Save to Files
        // is available in Safari's PDF viewer.
        const blob = doc.output("blob");
        const url = URL.createObjectURL(blob);

        const opened = window.open(url, "_blank");

        if (!opened) {
          // Some embedded browsers block popups.
          window.location.href = url;
        }

        if (help) {
          help.textContent =
            "In Safari, tap Share → Save to Files to keep your PDF.";
        }
      } else {
        doc.save(filename);
      }
    }

    root.querySelector(".bgs-cq__start")
      .addEventListener("click", startFreshQuiz);

    $('[data-action="home"]')
      .addEventListener("click", () => show("welcome"));

    $('[data-action="previous"]')
      .addEventListener("click", () => {
        if (page > 0) {
          page--;
          renderPage();
          show("quiz");
        }
      });

    $('[data-action="next"]')
      .addEventListener("click", () => {
        const start = page * PER_PAGE;
        const end = Math.min(start + PER_PAGE, QUESTIONS.length);

        let firstMissing = -1;

        for (let index = start; index < end; index++) {
          if (!answers[index]) {
            firstMissing = index;
            break;
          }
        }

        if (firstMissing !== -1) {
          $('[data-answer-error]').hidden = false;

          const missing = root.querySelector(
            `[data-question-index="${firstMissing}"]`
          );

          if (missing) {
            missing.classList.add(
              "bgs-cq__question-block--missing"
            );

            missing.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }

          return;
        }

        if (end === QUESTIONS.length) {
          showResults();
          return;
        }

        page++;
        renderPage();
        show("quiz");
      });

    $('[data-action="restart"]')
      .addEventListener("click", startFreshQuiz);

    $('[data-action="print"]')
      .addEventListener("click", savePdf);

    const restored = restoreProgress();

    if (restored) {
      renderPage();

      if (currentScreen === "results") {
        showResults(true);
      } else {
        show(currentScreen, false, false);
      }
    } else {
      show("welcome", false, false);
      updateProgress();
    }
  }

  function startAllQuizzes() {
    document.querySelectorAll("[data-bgs-quiz]")
      .forEach(initQuiz);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startAllQuizzes
    );
  } else {
    startAllQuizzes();
  }

  document.addEventListener(
    "shopify:section:load",
    startAllQuizzes
  );
})();
